import { render, staticRenderFns } from "./QsTab02.vue?vue&type=template&id=423da962&"
import script from "./QsTab02.vue?vue&type=script&lang=js&"
export * from "./QsTab02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports